<template>
  <div v-if="attachmentList.length" class="section">
    <div class="section-title">
      <base-section-title :class="{ 'text-bold': isBold }" title="答疑澄清" />
    </div>
    <div class="section-content w-800">
      <el-collapse v-model="activeNames">
        <el-collapse-item
          v-for="(item, index) in attachmentList"
          :key="index"
          :name="`${index}`"
        >
          <template slot="title">
            <div class="file-title">
              <div>
                <span
                  class="text-warning clarify-num"
                >第{{
                  Number(attachmentList.length) - Number(index)
                }}次澄清</span>
                <span
                  class="text-bold"
                >发布时间：{{ item.supplementTime }}</span>
              </div>
              <el-button
                type="text"
                size="medium"
                class="m-l-20"
                @click.stop="openNotice(item)"
              >查看澄清说明</el-button>
            </div>
          </template>
          <el-form
            class="m-t-10 detail-form"
            label-suffix="："
            label-width="120px"
          >
            <slot :data="item"></slot>
            <el-form-item label="澄清文件">
              <upload-authorization-file
                v-if="item.fileGroupId"
                ref="UploadAuthorizationFile"
                v-model="item.fileGroupId"
                style="width:600px"
                :preview-api="previewApi"
                :download-api="downloadApi"
                :translate-data="{
                  downloadTranslate: 'fileUrl'
                }"
                :props-data="{
                  disabled: true
                }"
                :request-params="{
                  isRelease: true,
                  orderId: orderId,
                  tradeId: tradeId,
                  fileGroupId: item.fileGroupId,
                  supplementId: item.supplementId
                }"
              />
              <span v-else> - </span>
            </el-form-item>
          </el-form>
        </el-collapse-item>
      </el-collapse>
    </div>

    <!----公告------>
    <bulletin-dialog
      :visible.sync="visible"
      title="澄清文件说明"
      :content="content"
    />
  </div>
</template>

<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import BulletinDialog from '@/components/common/Bulletins/BulletinDialog'
import UploadAuthorizationFile from '@/components/common/Upload/UploadAuthorizationFile'

export default {
  components: {
    BaseSectionTitle,
    BulletinDialog,
    UploadAuthorizationFile
  },

  props: {
    orderId: {
      type: [Number, String],
      default: ''
    },
    tradeId: {
      type: [Number, String],
      default: ''
    },
    attachmentList: {
      type: Array,
      default: () => []
    },
    previewApi: {
      type: Function,
      default: () => {}
    },
    downloadApi: {
      type: Function,
      default: () => {}
    },
    isBold: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      visible: false,
      activeNames: ['0'],
      content: ''
    }
  },

  methods: {
    /**
     * 打开公告
     */
    openNotice(row) {
      this.content = row.supplementRemark
      this.visible = true
    }
  }
}
</script>
<style lang="scss" scoped>
.w-800 {
  width: 800px;
}
.file-title {
  width: 100%;
  color: $text-color;
  font-weight: normal;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1 0 90%;
  order: 1;
  .clarify-num {
    border: 1px solid $warning-color;
    font-size: 12px;
    border-radius: 2px;
    padding: 2px 6px;
    margin-right: 4px;
  }
}
::v-deep {
  .el-collapse {
    border: none;
  }
  .el-collapse-item__header {
    background-color: $info-fifth-color;
    flex: 1 0 auto;
    line-height: 1;
    margin-top: 10px;
    padding: 10px 16px;
    height: 34px;
  }
  .el-collapse-item__wrap {
    border-bottom: none;
    background-color: $info-fifth-color;
  }
  .el-collapse-item__content {
    padding-bottom: 5px;
  }
  .el-divider {
    background-color: $dividing-color;
  }
  .el-divider--horizontal {
    width: 90%;
    margin: 10px auto;
  }
  .el-icon-arrow-right:before {
    content: '\e791';
  }
}
</style>
